import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { DialogService } from '../../../dialog/dialog.service';
import { CurrentPlan } from '../../../features-data/sub-models/current-plan.model';
import {
  FeedbackScreenEnum,
  IFeedbackCard,
} from '../../../feedback-data/feedback-data.data';
import { FeedbackDataDispatcher } from '../../../feedback-data/feedback-data.dispatcher';
import { Settings } from '../../../settings-data/settings.model';
import { IIcon } from '../../../shared/components/icon/icon.interface';
import { IconSizesEnum } from '../../../shared/components/icon/icons-sizes.enum';
import { DIALOG_TYPE as feedbackDialog } from '../feedback-dialog/feedback-dialog.component';
import {
  ITrackingProperties,
  ITrackingAction,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';
import { FeedbackTrackingObject } from '../../../tracking/models/objects/feedback-tracking-object.model';
import { TrackingObjectBuilder } from '../../../tracking/tracking-object.builder';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';

@Component({
  selector: 'app-feedback-card',
  templateUrl: './feedback-card.component.html',
  styleUrls: ['./feedback-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeedbackCardComponent implements OnInit, OnDestroy {
  @Input() accountId: string;
  @Input() feedbackScreenName: FeedbackScreenEnum;
  @Input() feedbackCard: IFeedbackCard;
  @Input() settings: Settings;
  @Input() currentPlan: CurrentPlan;
  @Input() userEmail: string;
  @Input() trackingScreenName: TrackingScreenNamesEnum;

  @Output() onSendFeedback: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  onCloseFeedbackCard: EventEmitter<string> = new EventEmitter<string>();

  megaphoneIcon: IIcon;
  closeIcon: IIcon;
  trackingObject: FeedbackTrackingObject;
  giveFeedbackTrackingAction: ITrackingAction;
  dismissTrackingAction: ITrackingAction;
  trackingAdditionalProperties: ITrackingProperties;

  constructor(
    private _feedbackDataDispatcher: FeedbackDataDispatcher,
    private _dialogService: DialogService,
    private _trackingObjectBuilder: TrackingObjectBuilder,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder
  ) {}

  ngOnInit() {
    this.megaphoneIcon = {
      name: 'megaphone',
      size: IconSizesEnum.x_large,
    };
    this.closeIcon = {
      name: 'close',
      size: IconSizesEnum.small,
    };

    this.trackingObject = this._trackingObjectBuilder.buildFeedback();
    this.trackingAdditionalProperties = {
      type: 'banner',
    };
    this.dismissTrackingAction = this._trackingActionBuilder.buildButtonTapped(
      'dismiss',
      this.trackingScreenName
    );
    this.giveFeedbackTrackingAction = this._trackingActionBuilder.buildButtonTapped(
      'give_feedback',
      this.trackingScreenName
    );
  }

  openFeedbackDialog() {
    this._dialogService.openDialog({ type: feedbackDialog });
  }

  closeFeedbackCard() {
    if (this.feedbackScreenName && this.accountId) {
      this._feedbackDataDispatcher.hideFeedbackCardForAccount(
        this.feedbackScreenName,
        this.accountId
      );
    }
  }

  ngOnDestroy() {
    this._dialogService.closeDialog({ type: feedbackDialog });
  }
}
